import { render, staticRenderFns } from "./Next.vue?vue&type=template&id=55460337&scoped=true&"
import script from "./Next.vue?vue&type=script&lang=js&"
export * from "./Next.vue?vue&type=script&lang=js&"
import style0 from "./Next.vue?vue&type=style&index=0&id=55460337&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55460337",
  null
  
)

export default component.exports